import { CheckCircleOutline, Close } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { isNil } from 'lodash';
import React from 'react';
import { FeatureFlagState } from '../../../graphql/types';

interface FeatureFlagDataProps {
  featureFlagState: FeatureFlagState;
}

export const FeatureFlagResult: React.FC<FeatureFlagDataProps> = ({
  featureFlagState,
}) => {
  return (
    <Box>
      <Typography
        variant="body1"
        display="flex"
        alignItems="center"
        gap={1}
        gutterBottom
      >
        <strong>Enabled:</strong>
        {featureFlagState.enabled ? (
          <CheckCircleOutline color="success" />
        ) : (
          <Close color="error" />
        )}
      </Typography>
      <Box display="flex" flexDirection="column">
        {!isNil(featureFlagState.value) && (
          <Box>
            <Typography variant="body1">
              <strong>Value:</strong>
            </Typography>
            <Box
              component="pre"
              sx={{
                p: 1,
                backgroundColor: 'grey.100',
                borderRadius: 2,
                fontSize: '0.875rem',
              }}
            >
              {JSON.stringify(featureFlagState.value, null, 2)}
            </Box>
          </Box>
        )}
        {!isNil(featureFlagState.attributes) && (
          <Box>
            <Typography variant="body1">
              <strong>Attributes:</strong>
            </Typography>
            <Box
              component="pre"
              sx={{
                p: 1,
                backgroundColor: 'grey.100',
                borderRadius: 2,
                fontSize: '0.875rem',
              }}
            >
              {JSON.stringify(featureFlagState.attributes, null, 2)}
            </Box>
          </Box>
        )}
      </Box>

      {isNil(featureFlagState.value) && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No config value associated with this feature flag.
        </Typography>
      )}
    </Box>
  );
};
